/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAlert } from '../../../Common/hooks';
import { getExceptionFilters } from '../../selectors';
import { getExceptionReports } from '../../services';
import { exceptionError } from '../../constants';

const useExceptionReport = () => {
  const filters = useSelector(getExceptionFilters);
  const { showAlert } = useAlert();
  const [exceptionReports, setExceptionReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleFilterChange = async () => {
    if (filters.aggregatorID && filters.payerID) {
      setIsLoading(true);
      const { exceptionCodes, status } = await getExceptionReports(filters);
      if (status === 404) {
        showAlert({ color: 'error', icon: 'exclamation', message: exceptionError });
      }

      setExceptionReports(exceptionCodes);
      setIsLoading(false);
    } else {
      setExceptionReports([]);
    }
  };

  useEffect(() => {
    handleFilterChange();
  }, [filters]);

  return {
    exceptionReports,
    isLoading,
  };
};

export default useExceptionReport;
